var ko = require('knockout');

function MyCoursesPage(params) {
  // 0 = Planned, 1 = Historical
  this.tabType = ko.observable(0);
  this.API = params.api;
  this.links = params.links;
  this.texts = params.texts;
}

MyCoursesPage.prototype.switchTab = function(tabType) {
  this.tabType(tabType);
};

module.exports = MyCoursesPage;
